// @flow
import createUniversalRoute from "../../utils/createUniversalRoute";

const routes = [
  {
    path: "/book-a-call",
    exact: true,
    name: "OnboardingForm",
  },
  {
    path: "/book-a-call/thank-you",
    name: "OnboardingThankYou",
  },
];

export default routes.map<*>(createUniversalRoute);
